<p-progressSpinner class="spinner_in_front" *ngIf="spinner"></p-progressSpinner>
<div class="ps-3 pe-3">
    <div class="row pb-2">
      <div class="row col-12">
        <div class="col-6 pe-0">
          <label class="lbl_pos_field">{{'MENU.MENU_NAME' | translate}}
            <i *ngIf="errorModel!=null && errorModel['Name']!=null"
               class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
               pTooltip="{{errorModel['Name']|translate}}" tooltipPosition="top"></i>
          </label>
          <input type="text" class="primary_input_field" [(ngModel)]="menuModel.name">
        </div>
        <div class="col-6 pe-0">
          <label class="lbl_pos_field">{{'MENU.SELECT_CURRENCY' | translate}}
            <i *ngIf="errorModel!=null && errorModel['Currency']!=null"
               class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
               pTooltip="{{errorModel['Currency']|translate}}" tooltipPosition="top"></i>
          </label>
          <p-dropdown *ngIf="selectedCurrency"
                      [options]="currencies"
                      [(ngModel)]="selectedCurrency"
                      [disabled]="currencyFormDisabled"
                      optionLabel="name"
                      optionValue="id"
                      class="pos_dropdown"
                      placeholder="Select currency">
            <ng-template let-currency pTemplate="item">
              <div class="d-flex justify-content-between">
                <span>{{currency.shortName}}</span>
                <div>
                  <span>{{currency.symbol}}</span>
                  <span class="currencies_dropdown_name">{{currency.name}}</span>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
        <div class="row col-12">
            <div class="col-6 pe-0">
                <label class="lbl_pos_field">{{'MENU.ADD_TO_CATEGORY' | translate}}
                    <i *ngIf="errorModel!=null && errorModel['CategoryId']!=null"
                        class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                        pTooltip="{{errorModel['CategoryId']|translate}}" tooltipPosition="top"></i>
                </label>
                <p-multiSelect (onChange)="onChangeCategory($event); needUpdateStructure=true;" id="myltiSelectId" class="pos_dropdown "
                    [options]="categoriesDropdownHelperModels" [(ngModel)]="menuModel.categoryIds" optionLabel="name"
                    optionValue="id" [showHeader]="false" [maxSelectedLabels]="4" display="chip" [virtualScroll]="true"
                    placeholder="{{'MENU.SELECT_CATEGORY' | translate}}">
                </p-multiSelect>
            </div>
            <div class="col-6 pe-0">
                <label class="lbl_pos_field">{{'MENU.ADD_TO_SUBCATEGORY' | translate}}
                    <i *ngIf="errorModel!=null && errorModel['SubcategoryId']!=null"
                        class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
                        pTooltip="{{errorModel['SubcategoryId']|translate}}" tooltipPosition="top"></i>
                </label>
                <p-multiSelect (onChange)="onChangeSubcategory($event); needUpdateStructure=true;" id="myltiSelectId_1" class="pos_dropdown" [options]="subcategoriesDropdownHelperModels"
                    [(ngModel)]="menuModel.subcategoryIds" optionLabel="name" optionValue="id" [showHeader]="false"
                    [maxSelectedLabels]="4" display="chip" placeholder="{{'MENU.SELECT_SUBCATEGORY' | translate}}"></p-multiSelect>
            </div>

            <div class="w-100 mt-3 div_menu_item " >
                <div *ngFor="let menuItems of listMenuItems" class="div_card_menu_item"
                    [class.menu_item_unselect]="isMenuSelected(menuItems)" (click)="addOrRemoveMenuItem(menuItems); needUpdateStructure=true;">
                    <div>
                        <img class="menu_item_image"
                            [src]="menuItems.pictureURL ? menuItems.pictureURL : imagePath ">
                    </div>
                    <div class="div_menu_item_lbl text-start" >
                        <label class=" ctg_lbl w-100">{{menuItems.name}}</label>
<!--                        <label class=" ctg_lbl fw-400 w-75">{{menuItems.categoryName}} , {{menuItems.subcategoryName}}-->
<!--                        </label>-->
                        <label class=" text-center  ctg_lbl ">{{menuItems.price}} {{menuItems.currency ? menuItems.currency.symbol : ''}}</label>
                    </div>

                </div>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-between pb-2">
            <button *ngIf="!enableEdit" class="btn_login w-100" (click)="addMenu(menuModel)">{{ 'SAVE' |
                translate}}</button>
            <button *ngIf="enableEdit" class="btn_login w-100" (click)="editMenu(menuModel)">{{ 'SAVE' |
                translate}}</button>
        </div>
    </div>
</div>
